import {RootStore} from '../stores/RootStore';
import {getOrigin} from './platform-service/getOrigin';
import {ProductType} from '@wix/wixstores-client-core/dist/es/src/types';
import {mapUserInputSelectionMapToChoices} from '../mappers/mapUserInputSelectionMapToChoices';
import {mapUserInputTextToFields} from '../mappers/mapUserInputTextToFields';
import {CustomTextOptionInput} from '@wix/wixstores-client-storefront-sdk/dist/es/src/__generated__/schemaTypes';
import {getCurrentLanguage, getDeviceType} from '../../../services/platform-service';
import {SPECS} from '../../../specs';
import {getActualSubscriptionPlanId} from './product-service/subscriptions/getActualSubscriptionPlanId';

const getCustomTextFieldSelection = (rootStore: RootStore): CustomTextOptionInput[] => {
  return rootStore.$state.textInput.reduce((fields, value, index) => {
    if (value) {
      const {isMandatory, key, title} = rootStore.$state.product.customTextFields[index];
      fields.push({title, isMandatory, key, value});
    }
    return fields;
  }, [] as CustomTextOptionInput[]);
};

export const createCheckout = async (
  rootStore: RootStore,
  {withNavigateToCheckout, isPreOrder}: {withNavigateToCheckout: boolean; isPreOrder?: boolean},
) => {
  const {
    ecomPublicApi: wixstoresApi,
    $state: {product, quantityInput},
  } = rootStore;

  if (rootStore.isExperimentEnabled(SPECS.PPOBCreateCheckoutFromPublicApi)) {
    const handleDirectPurchaseParams = {
      productId: product.id,
      productType: product.productType as ProductType,
      quantity: quantityInput,
      customTextFieldSelection: getCustomTextFieldSelection(rootStore),
      deviceType: getDeviceType(rootStore.wixCodeApi),
      originType: getOrigin(rootStore),
      variantId: rootStore.$state.selectedVariant ? rootStore.$state.variantId : undefined,
      optionSelectionId: rootStore.$state.selectionIds,
      options: mapUserInputSelectionMapToChoices(rootStore),
      subscriptionOptionId: getActualSubscriptionPlanId(rootStore.$state) || undefined,
      locale: getCurrentLanguage(rootStore.wixCodeApi),
      withNavigateToCheckout: false,
      preOrderRequested: isPreOrder,
      skipCreateCheckout: true,
    };

    void wixstoresApi.checkout.handleDirectPurchase(handleDirectPurchaseParams);

    const createCheckoutOptions = {
      customTextFields: mapUserInputTextToFields(rootStore),
      choices: mapUserInputSelectionMapToChoices(rootStore),
    };

    const checkout = await rootStore.storesPublicApi.checkout.createCheckout(
      product.id,
      quantityInput,
      createCheckoutOptions,
      isPreOrder,
    );

    withNavigateToCheckout && (await rootStore.ecomPublicApi.navigate.toCheckout({checkoutId: checkout._id} as any));
    return {checkoutId: checkout._id, cartId: null};
  } else {
    return wixstoresApi.checkout.handleDirectPurchase({
      productId: product.id,
      productType: product.productType as ProductType,
      quantity: quantityInput,
      customTextFieldSelection: getCustomTextFieldSelection(rootStore),
      deviceType: getDeviceType(rootStore.wixCodeApi),
      originType: getOrigin(rootStore),
      variantId: rootStore.$state.selectedVariant ? rootStore.$state.variantId : undefined,
      optionSelectionId: rootStore.$state.selectionIds,
      options: mapUserInputSelectionMapToChoices(rootStore),
      subscriptionOptionId: getActualSubscriptionPlanId(rootStore.$state) || undefined,
      locale: getCurrentLanguage(rootStore.wixCodeApi),
      withNavigateToCheckout,
      preOrderRequested: isPreOrder,
    });
  }
};
